import React from "react";
import { Box, Text, Flex } from "@chakra-ui/react"
import '../../assets/css/StatusProgress/style.css'
const StatusProgress = ({ statusOption }) => {
  return (
    <Box className="status-container" w="100%"
      bg="white"
      borderRadius="8px"
      boxShadow="0px 4px 8px rgba(0, 0, 0, 0.05)">
      <Flex justify="space-between" className="status-labels"  px="16px" py="20px">
        {statusOption.map((status, index) => (
          <Box key={index} textAlign="center">
            <Text className="status-text" fontWeight="600" fontSize="12px" mb="10px">{status.label}</Text>
            <Text className="status-value" fontWeight="700" fontSize="20px">{status.value}</Text>
          </Box>
        ))}
      </Flex>

      <Flex className="progress-bar" width="100%" height="4px" borderRadius="6px" overflow="hidden">
        {statusOption.map((status, index) => (
          <Box
            key={index}
            flex="1"
            height="100%"
            bg={status.color}
            borderBottomLeftRadius={index === 0 ? "6px" : "0"}
            borderBottomRightRadius={index === statusOption.length - 1 ? "6px" : "0"}
          />
        ))}
      </Flex>
    </Box>
  );
};

export default StatusProgress;
